import React from 'react';
import { setCurrentView } from 'core/utils';
import { ShipmentCostListTemplate } from 'themes/modules/shipment-cost/pages';
import { ShipmentCostListViewStore } from 'modules/shipment-cost/stores';

@setCurrentView(rootStore => new ShipmentCostListViewStore(rootStore), 'shipmentCostListViewStore')
class ShipmentCostList extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <ShipmentCostListTemplate {...this.props} viewStore={this.props.shipmentCostListViewStore} />;
	}
}

export default ShipmentCostList;



// WEBPACK FOOTER //
// ./src/modules/shipment-cost/pages/ShipmentCostList.jsx